import { create } from 'zustand';

/**
 * IMP-2294 — a Pair Connection prompt is delivered into a pair chat, so a recipient with no
 * active pair does not receive it. The server reports who was missed; this holds that report
 * until the admin dismisses it. It lives in a store rather than in the composer because every
 * composer closes itself on a successful send.
 */
export interface UndeliveredRecipient {
  _id: string;
  name: string;
  role: string;
}

export interface PromptDeliveryReport {
  totalRecipients: number;
  deliveredCount: number;
  undelivered: UndeliveredRecipient[];
}

interface PromptDeliveryReportStore {
  report: PromptDeliveryReport | null;
  setReport: (report: PromptDeliveryReport) => void;
  clearReport: () => void;
}

const usePromptDeliveryReport = create<PromptDeliveryReportStore>(set => ({
  report: null,
  setReport: report => set({ report }),
  clearReport: () => set({ report: null }),
}));

export default usePromptDeliveryReport;
